/* Remedy Booth — interactions */
(function(){
  'use strict';

  // Sticky header shadow
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  // Mobile drawer
  document.querySelectorAll('[data-drawer-open]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const sel = btn.getAttribute('data-drawer-open');
      document.querySelector(sel)?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btn.closest('.drawer, .cart-drawer')?.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });
  document.querySelectorAll('.drawer, .cart-drawer').forEach(d=>{
    d.addEventListener('click', e=>{
      if (e.target === d || e.target.classList.contains('cart-drawer__overlay')) {
        d.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  // PDP gallery
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main] img');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const track = gallery.querySelector('[data-thumbs-track]');
    let active = thumbs.findIndex(t => t.classList.contains('is-active'));
    if (active < 0) active = 0;

    const select = (idx) => {
      if (!thumbs.length) return;
      idx = (idx + thumbs.length) % thumbs.length;
      const t = thumbs[idx];
      thumbs.forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      active = idx;

      const full = t.getAttribute('data-full-src');
      const srcset = t.getAttribute('data-full-srcset');
      if (main && full) {
        main.style.opacity = '0';
        const swap = () => {
          main.src = full;
          if (srcset) main.setAttribute('srcset', srcset);
          main.removeAttribute('sizes');
          main.style.opacity = '1';
        };
        // wait for the fade then swap
        setTimeout(swap, 140);
      }
      // keep active thumb visible
      if (track && t.scrollIntoView) {
        t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    };

    thumbs.forEach((t, i) => t.addEventListener('click', () => select(i)));

    gallery.querySelector('[data-thumbs-prev]')?.addEventListener('click', () => select(active - 1));
    gallery.querySelector('[data-thumbs-next]')?.addEventListener('click', () => select(active + 1));

    // Arrow keys when gallery is focused/hovered
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); select(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); select(active + 1); }
    });
    gallery.setAttribute('tabindex', '0');

    // Tap to advance on the main image (mobile-friendly)
    const mainBox = gallery.querySelector('[data-gallery-main]');
    mainBox?.addEventListener('click', (e) => {
      // Don't hijack the zoom button
      if (e.target.closest('.pdp__zoom')) return;
      const rect = mainBox.getBoundingClientRect();
      const goPrev = (e.clientX - rect.left) < rect.width / 2;
      select(active + (goPrev ? -1 : 1));
    });

    // Touch swipe
    let touchStartX = null;
    mainBox?.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    mainBox?.addEventListener('touchend', (e) => {
      if (touchStartX == null) return;
      const dx = (e.changedTouches[0].clientX - touchStartX);
      if (Math.abs(dx) > 40) select(active + (dx < 0 ? 1 : -1));
      touchStartX = null;
    });

    // Cursor hint on the main image
    if (mainBox && thumbs.length > 1) mainBox.style.cursor = 'pointer';
  }

  // PDP swatches — frame color & lens color
  document.querySelectorAll('[data-swatch-group]').forEach(group=>{
    group.querySelectorAll('[data-swatch]').forEach(sw=>{
      sw.addEventListener('click', ()=>{
        group.querySelectorAll('[data-swatch]').forEach(x=>x.classList.remove('is-active'));
        sw.classList.add('is-active');
        const label = group.parentElement.querySelector('.val');
        if (label) label.textContent = sw.getAttribute('data-name');
        // Optional: change main image
        const img = sw.getAttribute('data-image');
        const mainImg = document.querySelector('[data-gallery-main] img');
        if (img && mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(()=>{ mainImg.src = img; mainImg.style.opacity = '1'; }, 150);
        }
        // Update price if variant data attached
        const price = sw.getAttribute('data-price');
        const priceEl = document.querySelector('[data-price-now]');
        if (price && priceEl) priceEl.textContent = price;
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('.qty').forEach(q=>{
    const input = q.querySelector('input');
    q.querySelector('[data-qty-down]').addEventListener('click', ()=>{
      input.value = Math.max(1, (parseInt(input.value,10)||1) - 1);
    });
    q.querySelector('[data-qty-up]').addEventListener('click', ()=>{
      input.value = (parseInt(input.value,10)||1) + 1;
    });
  });

  // Tabs
  document.querySelectorAll('[data-tabs]').forEach(tabs=>{
    const buttons = tabs.querySelectorAll('[data-tab]');
    const panels = tabs.querySelectorAll('[data-tab-panel]');
    buttons.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const id = btn.getAttribute('data-tab');
        buttons.forEach(b=>b.classList.toggle('is-active', b===btn));
        panels.forEach(p=>p.classList.toggle('is-active', p.getAttribute('data-tab-panel')===id));
      });
    });
  });

  // Newsletter (no-op unless on Liquid storefront)
  document.querySelectorAll('form[data-newsletter]').forEach(f=>{
    f.addEventListener('submit', e=>{
      // Allow real submit on Shopify; on static preview show a thanks state
      if (!window.Shopify) {
        e.preventDefault();
        f.innerHTML = '<div style="padding:12px 16px;font-size:14px">Thanks — you\u2019re on the list.</div>';
      }
    });
  });

  // PDP bundle pill toggle — variant selector (legacy, still used on non-glasses PDPs)
  document.querySelectorAll('[data-bundle-group]').forEach(group=>{
    const opts = group.querySelectorAll('[data-bundle-opt]');
    opts.forEach(opt=>{
      opt.addEventListener('click', e=>{
        if (opt.classList.contains('is-disabled')) { e.preventDefault(); return; }
        opts.forEach(x=>x.classList.remove('is-active'));
        opt.classList.add('is-active');
        const radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        const container = group.closest('.pdp__option');
        const labelVal = container?.querySelector('.val');
        const titleSpan = opt.querySelector('span');
        if (labelVal && titleSpan) labelVal.textContent = titleSpan.textContent;

        const priceNow = document.querySelector('[data-price-now]');
        const price = opt.getAttribute('data-price');
        if (priceNow && price) priceNow.textContent = price;

        // Toggle add-to-cart availability
        const available = opt.getAttribute('data-available') === 'true';
        const submit = document.querySelector('#product-form button[type=submit]');
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? 'Add to cart' : 'Sold out';
        }
      });
    });
  });

  // Header search overlay
  document.querySelectorAll('[data-open-search]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const overlay = document.querySelector('[data-search-overlay]');
      if (!overlay) return;
      overlay.hidden = false;
      requestAnimationFrame(()=>{
        overlay.classList.add('is-open');
        overlay.querySelector('input[type=search]')?.focus();
      });
    });
  });
  document.querySelectorAll('[data-close-search]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const overlay = btn.closest('[data-search-overlay]');
      overlay?.classList.remove('is-open');
      setTimeout(()=>{ if (overlay) overlay.hidden = true; }, 200);
    });
  });
  document.addEventListener('keydown', e=>{
    if (e.key === 'Escape') {
      const overlay = document.querySelector('[data-search-overlay].is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        setTimeout(()=>{ overlay.hidden = true; }, 200);
      }
    }
  });

  // Cart drawer open hooks
  function openCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  document.querySelectorAll('[data-open-cart]').forEach(btn=>{
    btn.addEventListener('click', e=>{
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) { e.preventDefault(); openCartDrawer(); }
    });
  });

  // Refresh the cart drawer body via Section Rendering API after multi-add
  async function refreshCartDrawer() {
    try {
      const r = await fetch('/?sections=cart-drawer');
      if (!r.ok) return;
      const data = await r.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-cart-drawer]');
      const live = document.querySelector('[data-cart-drawer]');
      if (fresh && live) {
        const wasOpen = live.classList.contains('is-open');
        live.replaceWith(fresh);
        if (wasOpen) fresh.classList.add('is-open');
      }
      // Update header cart badge
      const cartR = await fetch('/cart.js');
      if (cartR.ok) {
        const cart = await cartR.json();
        document.querySelectorAll('[data-cart-count]').forEach(b => b.textContent = cart.item_count);
      }
    } catch (e) { /* ignore */ }
  }

  // PDP frame swatches (Day/Night Glasses): swap variant + filter gallery + update kit price
  document.querySelectorAll('[data-frame-swatches]').forEach(group => {
    const swatches = group.querySelectorAll('[data-frame-swatch]');
    swatches.forEach(sw => {
      sw.addEventListener('click', e => {
        if (sw.classList.contains('is-disabled')) return;
        e.preventDefault();
        swatches.forEach(s => s.classList.remove('is-active'));
        sw.classList.add('is-active');

        const variantId = sw.getAttribute('data-variant-id');
        const frameName = sw.getAttribute('data-frame-name');
        const price = sw.getAttribute('data-price');

        // Update hidden variant input
        const hidden = document.querySelector('[data-variant-id-input]');
        if (hidden) hidden.value = variantId;

        // Update visible label + price
        const label = group.parentElement?.querySelector('[data-variant-label]');
        if (label) label.textContent = frameName;
        const priceNow = document.querySelector('[data-price-now]');
        if (priceNow && price) priceNow.textContent = price;
        const singlePrice = document.querySelector('[data-kit-price-single]');
        if (singlePrice && price) singlePrice.textContent = price;

        // Filter primary-side gallery thumbs to the active frame
        applyGalleryFilter();

        // Update the "current variant" image in kit cards
        const firstPrimary = document.querySelector('[data-gallery-thumb][data-side="primary"]:not(.is-hidden)');
        const newSrc = firstPrimary?.querySelector('img')?.getAttribute('src')?.replace(/width=\d+/, 'width=400');
        document.querySelectorAll('[data-kit-img-current]').forEach(img => {
          if (newSrc) img.src = newSrc;
        });

        // Update the URL so deep-links work (push state, no reload)
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId.split('/').pop());
          window.history.replaceState({}, '', url.toString());
        } catch (_) {}
      });
    });
  });

  // Filter gallery thumbs based on (a) active primary frame, (b) kit-tier active,
  // and (c) active cross frame when set is active.
  function applyGalleryFilter() {
    const primaryActive = document.querySelector('[data-frame-swatch].is-active');
    const primaryFrame = primaryActive?.getAttribute('data-frame-name');
    const setActive = document.querySelector('[data-kit-card][data-kit-type="set"]')?.classList.contains('is-active');
    const crossActive = document.querySelector('[data-cross-frame-swatch].is-active');
    const crossFrame = crossActive?.getAttribute('data-frame-name');

    const thumbs = document.querySelectorAll('[data-gallery-thumb]');
    let firstShown = null;
    thumbs.forEach(t => {
      const side = t.getAttribute('data-side');
      const tFrame = t.getAttribute('data-frame');
      let show;
      if (side === 'cross') {
        show = setActive && (!tFrame || tFrame === crossFrame);
      } else {
        show = !tFrame || tFrame === primaryFrame;
      }
      t.classList.toggle('is-hidden', !show);
      if (show && !firstShown) firstShown = t;
    });
    if (firstShown) firstShown.click();
  }

  // PDP kit-picker: toggle which kit tier is active
  document.querySelectorAll('[data-kit-picker]').forEach(picker => {
    const cards = picker.querySelectorAll('[data-kit-card]');
    cards.forEach(card => {
      card.addEventListener('click', e => {
        cards.forEach(c => c.classList.remove('is-active'));
        card.classList.add('is-active');
        const radio = card.querySelector('input[type=radio]');
        if (radio) radio.checked = true;

        // Show/hide cross-frame swatch row when set is active
        const isSet = card.getAttribute('data-kit-type') === 'set';
        const crossRow = document.querySelector('[data-cross-frame-row]');
        if (crossRow) crossRow.hidden = !isSet;

        // Refilter the gallery to include / exclude cross thumbs
        applyGalleryFilter();
      });
    });
  });

  // Cross-frame swatch (Night frame on Day PDP, Day frame on Night PDP)
  document.querySelectorAll('[data-cross-frame-swatches]').forEach(group => {
    const swatches = group.querySelectorAll('[data-cross-frame-swatch]');
    swatches.forEach(sw => {
      sw.addEventListener('click', e => {
        if (sw.classList.contains('is-disabled')) return;
        e.preventDefault();
        swatches.forEach(s => s.classList.remove('is-active'));
        sw.classList.add('is-active');

        const newCrossId = sw.getAttribute('data-variant-id');
        const newCrossName = sw.getAttribute('data-frame-name');
        const newCrossImg = sw.getAttribute('data-image-url');

        const form = document.querySelector('[data-pdp-form]');
        if (form && newCrossId) form.setAttribute('data-cross-variant-id', newCrossId);

        const label = group.parentElement?.querySelector('[data-cross-variant-label]');
        if (label) label.textContent = newCrossName;

        // Swap the cross product preview in the set kit-card
        const crossImg = document.querySelector('[data-kit-img-cross]');
        if (crossImg && newCrossImg) crossImg.src = newCrossImg;

        applyGalleryFilter();
      });
    });
  });

  // PDP form submit interceptor — handles both single and kit-set add-to-cart
  const pdpForm = document.querySelector('[data-pdp-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', async e => {
      e.preventDefault();

      const submit = pdpForm.querySelector('[data-pdp-submit]');
      const submitLabel = pdpForm.querySelector('[data-submit-label]');
      const originalLabel = submitLabel?.textContent || 'Add to cart';
      if (submit) { submit.disabled = true; }
      if (submitLabel) submitLabel.textContent = 'Adding…';

      const variantId = pdpForm.querySelector('[data-variant-id-input]')?.value;
      const qty = parseInt(pdpForm.querySelector('input[name=quantity]')?.value || '1', 10);
      const kitType = pdpForm.querySelector('input[name=kit_type]:checked')?.value || 'single';
      const isKit = pdpForm.getAttribute('data-kit-pdp') === 'true';
      const crossVariantId = pdpForm.getAttribute('data-cross-variant-id');

      const items = [{ id: variantId, quantity: qty }];
      if (isKit && kitType === 'set' && crossVariantId) {
        items.push({ id: crossVariantId, quantity: qty });
      }

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          if (submitLabel) submitLabel.textContent = err.description || 'Could not add';
          setTimeout(() => { if (submitLabel) submitLabel.textContent = originalLabel; if (submit) submit.disabled = false; }, 2200);
          return;
        }
        await refreshCartDrawer();
        openCartDrawer();
        if (submitLabel) submitLabel.textContent = 'Added ✓';
        setTimeout(() => { if (submitLabel) submitLabel.textContent = originalLabel; if (submit) submit.disabled = false; }, 1400);
      } catch (err) {
        if (submitLabel) submitLabel.textContent = 'Error — try again';
        setTimeout(() => { if (submitLabel) submitLabel.textContent = originalLabel; if (submit) submit.disabled = false; }, 2200);
      }
    });
  }
})();
